import { forEach } from 'lodash';
const _ = require('lodash');

export const dimAndAttributeFormater = (dimListResponseArray: any) => {
    const dimAndAttribute = dimListResponseArray?.dimention?.map((item: any, key: number) => {
        const temp = { ...item, attribute: [...(dimListResponseArray?.[item?.dimensionReference] || [])] }; //need to change this
        return temp;
    });
    //for attribute types
    const attributeTypesObj: any = {};
    dimAndAttribute?.forEach((item: any) => {
        attributeTypesObj[item?.dimensionReference] = [];
        item?.attribute?.forEach((attr: any) => {
            attributeTypesObj[item?.dimensionReference]?.push(attr?.name);
        });
    });
    return { attributeTypesObj, dimAndAttribute };
};

export const getSelectedAttributeNameFrom = (allCheckedAttribute: any, attributeType: string) => {
    let allSelected: any = [];
    Object.keys(allCheckedAttribute[attributeType]).forEach(function (key, index) {
        allSelected.push(allCheckedAttribute[attributeType][key]);
    });
    return allSelected;
};

//to get apply filter object from inclusion and exclusion list of each attribute type
export const getApplyFilterObject = (original: any) => {
    const transformed: any = {};

    // Loop over each dimension in the original object
    for (const dim in original) {
        // Create a new object for this dimension in the transformed object
        transformed[`jsonstring_${dim}`] = {
            inclusion: [],
            exclusion: [],
        };

        // Loop over each attribute in this dimension
        for (const attr in original[dim]) {
            const attrDetails = original[dim][attr];

            // If there is an "inclusion" array, add it to the transformed object's "inclusion" array
            if (attrDetails.inclusion) {
                transformed[`jsonstring_${dim}`].inclusion.push(...attrDetails.inclusion);
            }

            // If there is an "exclusion" array, add it to the transformed object's "exclusion" array
            if (attrDetails.exclusion) {
                transformed[`jsonstring_${dim}`].exclusion.push(...attrDetails.exclusion);
            }
        }
    }
    //remove empty inclusion and exclusion
    for (let dim in transformed) {
        if (!transformed[dim].inclusion.length) {
            delete transformed[dim].inclusion;
        }
        if (!transformed[dim].exclusion.length) {
            delete transformed[dim].exclusion;
        }
    }
    return transformed;
};

//to filter apply filter the object according to config for promo score card
export function getFilteredApplyFilterObject(data: any, listToBeFiltered: any) {
    for (let dim in data) {
        for (let attr in data[dim]) {
            if (listToBeFiltered.includes(attr)) {
                delete data[dim][attr];
            }
        }
    }
    return data;
}

//remove the attributeType by clicking on expanded filter cell
export const removeAttrbuteNameByOnClick = (allCheckedAttribute: any, attributeName: string, attributeType: string) => {
    let temp = _.cloneDeep(allCheckedAttribute);
    Object.keys(allCheckedAttribute[attributeType]).forEach((attrName) => {
        if (attributeName === attrName) {
            delete temp[attributeType][attrName];
        }
    });
    return temp;
};

//remove the attribute type from the object onclick of the clear button of each attribute type(expanded filter view)
export const removeAttributeType = (allCheckedAttribute: any, attributeType: string) => {
    let temp = _.cloneDeep(allCheckedAttribute);
    temp[attributeType] = {};
    return temp;
};

export function createObjectForCheckList(
    checkBoxObj: any,
    e: any,
    attributeType: string,
    setAllCheckedAttribute: Function,
    allCheckedAttribute: any,
) {
    if (e.target.checked) {
        let temp: any = _.cloneDeep(allCheckedAttribute);
        temp[attributeType] = { ...temp[attributeType], [checkBoxObj?.attributeExId]: checkBoxObj };
        setAllCheckedAttribute(temp);
    } else {
        let temp: any = _.cloneDeep(allCheckedAttribute[attributeType]);
        delete temp[checkBoxObj.attributeExId];
        setAllCheckedAttribute((oldData: any) => ({ ...oldData, [attributeType]: temp }));
    }
}
//Initial call
export function createChecklistObjectFromInitialCall(
    allAttributeName: any,
    setAllCheckedAttribute: Function,
    defaultList: any,
    loadingRef: any,
) {
    let finalObject: any = {};
    Object.keys(allAttributeName).forEach((attributeType: any) => {
        let temp: any = {};
        allAttributeName[attributeType].forEach((attributeNameObj: any) => {
            temp[attributeNameObj.attributeExId] = attributeNameObj;
            finalObject[attributeType] = temp;
        });
    });
    //overwriting default filter with rbac here if rbac exists
    if (Object.keys(defaultList).length) {
        for (let dim in defaultList) {
            let attrLevel = defaultList[dim];
            for (let attribute in attrLevel) {
                finalObject[attribute] = {};
                const inclusion = attrLevel[attribute]?.inclusion || [];
                inclusion.forEach((inclusionObj: any) => {
                    finalObject[inclusionObj.attributeType][inclusionObj.attributeExId] = inclusionObj;
                });
            }
        }
    }
    setAllCheckedAttribute((oldData: any) => ({ ...oldData, ...finalObject }));
    loadingRef.current = false;
}

export function allDimAndAttributeTypeObjectTOListOfAttributeTypeArray(allDimAndAttributeType: any) {
    let allAttributeTypeArray: any = [];
    allDimAndAttributeType.dimentions.forEach((dim: any) => {
        let temp = dim.attribute?.map((attributeName: any) => {
            const tempAttributeName = { ...attributeName };
            tempAttributeName.dimensionReference = dim.dimensionReference;
            tempAttributeName.dimensionName = dim.dimensionName;
            return tempAttributeName;
        });
        allAttributeTypeArray.push(...temp);
    });
    return allAttributeTypeArray;
}

export function setAllDimAndAttributeTypeListCreate(allDimAndAttributeType: any) {
    let temp = _.cloneDeep(allDimAndAttributeType);
    allDimAndAttributeType.dimentions.forEach((dim: any, key: any) => {
        let tempDim = allDimAndAttributeType.dimentions[key];
        let tempArr = dim.attribute?.map((attributeName: any) => {
            attributeName.dimensionReference = dim.dimensionReference;
            attributeName.dimensionName = dim.dimensionName;
            return attributeName;
        });
        tempDim.attribute = tempArr;
        allDimAndAttributeType.dimentions[key] = tempDim;
    });
    return temp;
}

//
export function addAttributeTypeToAllCheckedAttribute(
    setAllCheckedAttribute: Function,
    attributeType: any,
    allAttributeNames: any,
) {
    let temp: any = {};
    allAttributeNames.forEach((attributeName: any) => {
        if (attributeName.isActive) {
            temp[attributeName.attributeExId] = attributeName;
        }
    });
    setAllCheckedAttribute((oldData: any) => ({ ...oldData, [attributeType]: temp }));
}

//take previous selection for the attribute name list of filter
export function previousAttributeSelection(
    setPreviousSelectedAttributesInUI: Function,
    e: any,
    allCheckedAttribute: any,
    attributeType: any,
    dimension: any,
) {
    setPreviousSelectedAttributesInUI((oldData: any) => {
        if (oldData[dimension.dimensionReference][oldData[dimension.dimensionReference].length - 1] !== attributeType) {
            oldData[dimension.dimensionReference].push(attributeType);
            return oldData;
        } else if (Object.keys(allCheckedAttribute?.[attributeType] || {})?.length == 1 && e.target.checked == false) {
            let filteredArray = oldData[dimension.dimensionReference].filter(
                (attribute: string) => attribute != attributeType,
            );
            oldData[dimension.dimensionReference] = filteredArray;
            return oldData;
        } else {
            return oldData;
        }
    });
}

//for include and exclude
export function excludeIncludeEngine(
    checkBoxObj: any,
    e: any,
    attributeType: string,
    applyFilterObject: any,
    setApplyFilterObject: Function,
    dimension: any,
    allSelectedValueForAllAttribute: any,
    attributeNamesData?: any,
) {
    let applyFilterObjectTemp = _.cloneDeep(applyFilterObject);
    //exclude
    if (e.target.checked === false && allSelectedValueForAllAttribute[attributeType] === true) {
        delete applyFilterObjectTemp[dimension.dimensionReference]?.[attributeType]?.inclusion;
        //  applyFilterObjectTemp[dimension.dimensionReference][attributeType].exclusion.push(checkBoxObj);
        if (applyFilterObjectTemp[dimension.dimensionReference][attributeType].exclusion) {
            applyFilterObjectTemp[dimension.dimensionReference][attributeType].exclusion?.push(checkBoxObj);
        } else {
            applyFilterObjectTemp[dimension.dimensionReference][attributeType].exclusion = [checkBoxObj];
        }
    } else if (e.target.checked === true && allSelectedValueForAllAttribute[attributeType] === true) {
        delete applyFilterObjectTemp[dimension.dimensionReference]?.[attributeType]?.inclusion;

        //filter out from exclusion
        let filteredExclusion = applyFilterObjectTemp[dimension.dimensionReference][attributeType].exclusion.filter(
            (item: any) => item.attributeExId != checkBoxObj.attributeExId,
        );
        applyFilterObjectTemp[dimension.dimensionReference][attributeType] = filteredExclusion.length
            ? { exclusion: filteredExclusion }
            : {};
    }
    //include
    else if (e.target.checked === true && allSelectedValueForAllAttribute[attributeType] === false) {
        delete applyFilterObjectTemp[dimension.dimensionReference]?.[attributeType]?.exclusion;

        if (applyFilterObjectTemp[dimension.dimensionReference][attributeType].inclusion) {
            applyFilterObjectTemp[dimension.dimensionReference][attributeType].inclusion?.push(checkBoxObj);
        } else {
            applyFilterObjectTemp[dimension.dimensionReference][attributeType].inclusion = [checkBoxObj];
        }

        // if (
        //     applyFilterObjectTemp[dimension.dimensionReference]?.[attributeType]?.inclusion?.length+1 ===
        //     attributeNamesData.meta.count
        // ) {
        //     applyFilterObjectTemp[dimension.dimensionReference][attributeType].inclusion = [];
        // }
    } else if (e.target.checked === false && allSelectedValueForAllAttribute[attributeType] === false) {
        delete applyFilterObjectTemp[dimension.dimensionReference]?.[attributeType]?.exclusion;
        //filter out from inclusion
        let filteredInclusion = applyFilterObjectTemp[dimension.dimensionReference][attributeType].inclusion.filter(
            (item: any) => item.attributeExId != checkBoxObj.attributeExId,
        );
        applyFilterObjectTemp[dimension.dimensionReference][attributeType] = filteredInclusion.length
            ? { inclusion: filteredInclusion }
            : {};
    }
    setApplyFilterObject(() => applyFilterObjectTemp);
}

export function applyFilterObjectAdd(applyFilterObject: any, configDefault: any) {
    let rbacDefault = JSON.parse(localStorage.getItem('userAccessScope') || '{}')?.data_metrics?.data_types;
    //prefer rbac first
    let copyConfigDefault = { ...configDefault, ...rbacDefault };
    for (let dim in copyConfigDefault) {
        if (dim in applyFilterObject) {
            for (let attr in copyConfigDefault[dim]) {
                let temp = applyFilterObject[dim][attr];

                //INCLUSION
                if (copyConfigDefault[dim]?.[attr]?.inclusion && temp) {
                    temp.inclusion = [...copyConfigDefault[dim][attr].inclusion];
                }
                //EXCLUSION
                if (copyConfigDefault[dim]?.[attr]?.exclusion && temp) {
                    temp.exclusion = [...copyConfigDefault[dim][attr].exclusion];
                }
                if (temp) applyFilterObject[dim][attr] = temp;
            }
        }
    }
    return applyFilterObject;
}

export function initializeApplyFilter(attributeType: any) {
    let oldData: any = { dim1: {}, dim2: {} };
    for (let dim in attributeType) {
        let data: any = {};
        attributeType[dim].forEach((attrType: any) => {
            data[attrType] = {};
        });
        oldData[dim] = data;
    }
    return oldData; //{dim:{attr:{}}}
}

export function initializeSelectAllValues(attributeType: any) {
    let data: any = {};
    for (let dim in attributeType) {
        attributeType[dim].forEach((attrType: any) => {
            data[attrType] = false;
        });
    }
    return data;
}
export function initializeAllSelectedObject(attributeType: any) {
    let data: any = {};
    for (let dim in attributeType) {
        attributeType[dim].forEach((attrType: any) => {
            data[attrType] = {};
        });
    }
    return data;
}

export function createDefaultFilterObject(applyFilterObject: any) {
    const clonedApplyFilterObject = _.cloneDeep(applyFilterObject);
    for (let dim in clonedApplyFilterObject) {
        for (let attr in clonedApplyFilterObject[dim]) {
            if (Object.keys(clonedApplyFilterObject[dim][attr])?.length === 0) {
                delete clonedApplyFilterObject[dim][attr];
            }
        }
    }
    return clonedApplyFilterObject;
}

export function initialize(
    applyFilterObject: any,
    defaultObjSelection: any,
    applyFilterObjectAdd: Function,
    setApplyFilterObject: Function,
    getApplyFilterObject: Function,
    callId: Function,
    applyFilterMutate: any,
    promoScoreCardConfig: any,
    getFilteredApplyFilterObject: any,
    createFilterB: Function,
    applyFilterForFilterB: any,
    enableFilterBCall: boolean,
) {
    // if (route.pathname.includes('promo-score-card')) {
    let appendedDefault = applyFilterObjectAdd(applyFilterObject, defaultObjSelection);
    //store appended default attribute type
    setApplyFilterObject(appendedDefault);
    //formatted applyFilter
    let formattedObjectForCall = getApplyFilterObject(appendedDefault);
    //call id for the ui - for global filter
    callId(formattedObjectForCall, applyFilterMutate);
    //filterB  - for promo score card
    if (enableFilterBCall)
        createFilterB(
            appendedDefault,
            promoScoreCardConfig,
            getFilteredApplyFilterObject,
            applyFilterForFilterB,
            callId,
        );
}
//Find the dim from app config
export function findDim(listOfAttrType: any, attributeType: any) {
    for (let dim in listOfAttrType) {
        if (listOfAttrType[dim].includes(attributeType)) {
            return dim;
        }
    }
}
// //to remove the inclusion and exclusion for the current attribute type
export function removeEverythingForRespectiveAttrTypeOfApplyFilter(
    applyFilterObject: any,
    attributeType: any,
    listOfAttrType: any,
) {
    let copyOfApplyFilterObject = _.cloneDeep(applyFilterObject);
    let dim: any = findDim(listOfAttrType, attributeType);
    copyOfApplyFilterObject[dim][attributeType] = {};
    return copyOfApplyFilterObject;
}
//set all select state of all attribute type false as we remove the side bar
export function changeSelectAllOfCurrentAttrType(allSelectedValueForAllAttribute: any, attributeType: any) {
    let copyOfAllSelectedValueForAllAttribute = _.cloneDeep(allSelectedValueForAllAttribute);
    copyOfAllSelectedValueForAllAttribute[attributeType] = false;
    return copyOfAllSelectedValueForAllAttribute;
}

export function changePeriodAccordingToScreen(screenName: any, list: any, globalFilterConfig: any = {}) {
    let resultList: any = [];
    const timePeriodScreenMapping = globalFilterConfig?.timePeriodScreenMapping?.[screenName];
    const timePeriodScreenMappingDefault = globalFilterConfig?.timePeriodScreenMapping?.['default'];
    //if different time period mapping exists use that, else use default time period
    if (timePeriodScreenMapping) {
        list.forEach((timePeriodObj: any) => {
            if (timePeriodScreenMapping.includes(timePeriodObj.timePeriod.toUpperCase())) {
                resultList.push(timePeriodObj);
            }
        });
        return resultList;
    } else {
        list.forEach((timePeriodObj: any) => {
            if (timePeriodScreenMappingDefault.includes(timePeriodObj.timePeriod.toUpperCase())) {
                resultList.push(timePeriodObj);
            }
        });
        return resultList;
    }
}

//to get the count of the
export function findTheCountOfDisabledAttributeNames(attributeNames: any) {
    let count = 0;
    attributeNames.forEach((attrName: any) => {
        if (!attrName.isActive) {
            count++;
        }
    });
    return count;
}
//get apply filter formate for every attribute name list call for attribute ui
export function returnApplyFilter(applyFilterObject: any, attributeType: any) {
    let tempFormate: any = { jsonstring_dim1: '{}', jsonstring_dim2: '{}' };
    let copyOfApplyFilterObject = _.cloneDeep(applyFilterObject);
    //delete current attribute names selection
    delete copyOfApplyFilterObject[attributeType.dimensionReference][attributeType.name];
    //formate the apply filter
    let formattedApplyFilter = getApplyFilterObject(copyOfApplyFilterObject);
    tempFormate[`jsonstring_${attributeType.dimensionReference}`] = JSON.stringify(
        formattedApplyFilter[`jsonstring_${attributeType.dimensionReference}`],
    );
    return tempFormate;
}

//constructs filter object for new attribute name api
//added cross dimension
//added exclusion/inclusion logic
export function constructFilterObject(applyFilterObject: any, attributeType: string) {
    const copyOfApplyFilterObject = _.cloneDeep(applyFilterObject);
    const filters: { inclusion: any[]; exclusion: any[] } = {
        inclusion: [],
        exclusion: [],
    };

    // Iterate over the main dimensions (dim1, dim2, etc.)
    for (const dim in copyOfApplyFilterObject) {
        const attributes = copyOfApplyFilterObject[dim];
        //delete current attribute names selection
        delete copyOfApplyFilterObject[dim]?.[attributeType];
        // Iterate over each attribute (e.g., Manufacturer, Category, etc.)
        for (const attr in attributes) {
            if (attributes[attr]?.inclusion) {
                // For inclusion attributes
                attributes[attr]?.inclusion?.forEach((item: any) => {
                    filters.inclusion.push({
                        attributeType: item.attributeType,
                        attributeDesc: item.attributeDesc,
                        attributeExId: item.attributeExId,
                        dimension: item.dimension,
                    });
                });
            }
            if (attributes[attr]?.exclusion) {
                // For exclusion attributes
                attributes[attr]?.exclusion?.forEach((item: any) => {
                    filters.exclusion.push({
                        attributeType: item.attributeType,
                        attributeDesc: item.attributeDesc,
                        attributeExId: item.attributeExId,
                        dimension: item.dimension,
                    });
                });
            }
        }
    }
    return filters;
}

//checks if global filter is empty by checking allcheckedattribute variable
export function isGlobalFilterEmpty(allCheckedAttribute: any) {
    for (let attr in allCheckedAttribute) {
        if (Object.keys(allCheckedAttribute[attr])?.length) {
            return false;
        }
    }
    return true;
}
